import { IRole } from '../../models/role.model';
import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { AppAction } from '../app';
import { FETCH_ROLE_LIST } from './role.actions';
import { RoleState } from './role.types';

const initialState: RoleState = {
  errorMessage: '',
  item: {} as Readonly<IRole>,
  items: [] as IRole[],
  loading: false,
  totalItems: 0,
};

export default (state: RoleState = initialState, action: AppAction): RoleState => {
  switch (action.type) {
    case REQUEST(FETCH_ROLE_LIST):
      return { ...state, loading: true };
    case SUCCESS(FETCH_ROLE_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_ROLE_LIST):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    default:
      return state;
  }
};
